import React from 'react'
import PPEAnalyticsDashboard from './PPEAnalyticsDashboard'
import ApexDashboard from './ApexDashboard'

const App = () => {
  return (
    <>
    <ApexDashboard/>
    </>
  )
}

export default App